## 1. مقدمه

این شرایط و ضوابط برای استفاده از قابلیت استرداد (Refund) تدوین شده است. برای فعال‌سازی این قابلیت، لازم است پذیرنده موافقت خود را با شرایط و قوانین ذکر شده در این توافقنامه اعلام کند.

نکته: موافقت با این شرایط و ضوابط به معنای پذیرش تمامی بندهای ذکر شده می‌باشد.

## 2. تعریف اصطلاحات

- پذیرنده: کسب‌وکار یا شخص حقوقی که از خدمات پرداخت استفاده می‌کند.
- استرداد: بازگشت کل یا بخشی از مبلغ تراکنش به مشتری، طبق شرایط تعیین‌شده.
- تراکنش اصلی: هرگونه پرداخت ثبت‌شده توسط مشتری بر روی ترمینال‌های فعال پذیرنده که توسط پی‌پینگ پشتیبانی می‌شوند است.
- تراکنش استرداد: تراکنش استرداد متناظر با تراکنش اصلی که می‌تواند کوچکتر یا مساوی مبلغ اصلی باشد
- کارمزد استرداد: مبلغی که بابت پردازش درخواست ریفاند از پذیرنده دریافت می‌شود.
- کیف پول استرداد پذیرنده: حساب دیجیتالی پذیرنده نزد پی‌پینگ که برای تامین منابع تراکنش‌های استرداد مورد استفاده قرار میگیرد.
- پرداخت کننده کارمزد: پرداخت کننده کارمزد تراکنش استرداد میتواند پذیرنده یا مشتری باشد.

## 3. شرایط فعال‌سازی قابلیت ریفاند

1. پذیرنده باید یک یا چند ترمینال فعال داشته باشد، (مراحل ثبت‌نام و احراز هویت را کامل کرده باشد، شامل ارائه مدارک شناسایی و اطلاعات بانکی معتبر).
1. حساب کاربری پذیرنده نباید هیچ محدودیت یا تعلیقی از سمت پلتفرم داشته باشد.
1. هرگونه سوء استفاده یا نقض این شرایط منجر به تعلیق یا لغو قابلیت ریفاند خواهد شد.

## 4. قوانین استفاده از قابلیت ریفاند

1. ریفاند تنها برای تراکنش‌های معتبر و پس از تأیید درخواست انجام می‌شود.
1. مبلغ ریفاند نباید از مبلغ تراکنش اصلی تجاوز کند.
1. برای پردازش ریفاند، پذیرنده موظف است موجودی کافی در ولت خود داشته باشد.

- در صورت عدم موجودی کافی، ریفاند ثبت میگردد اما وضعیت آن در انتظار شارژ باقی میماند وانجام نمی‌شود، پذیرنده موظف است کیف پول استرداد خود را شارژ کند.

1. درصورتی که کارمزد سمت پذیرنده تنظیم شده باشد(Bwage)، کارمزد ریفاند به‌صورت خودکار از ولت مرچنت کسر خواهد شد،‌ و درصورتی که کارمزد ریفاند سمت کاربر تنظیم شده باشد(Pwage) به‌صورت خودکار از مبلغ نهایی که برای کاربر عودت داده می‌شود کسر میگردد .
1. چنانچه تراکنش استرداد نیاز به شماره کارت مشتری داشته باشد، الزاما کارتی که پرداخت اصلی با آن ساخته‌شده و به نام خود مشتری است مبنا قرار خواهد گرفت و در غیر این صورت امکان استرداد وجود نخواهد داشت.
1. امکان استرداد وجه به انواع کارت‌های هدیه، بن‌کارت و غیره وجود نخواهد داشت.

## 5. قوانین مربوط به کارمزد و شارژ ولت

1. میزان کارمزد:

- کارمزد ریفاند به‌صورت درصدی از مبلغ ریفاند یا به‌صورت مبلغ ثابت (بر اساس توافق) محاسبه می‌شود. که قابلیت مذاکره براساس شرایط مختلف وجود دارد.

1. شارژ ولت مرچنت:

- مرچنت باید پیش از استفاده از قابلیت استرداد، اطمینان حاصل کند که ولت دیجیتالی او دارای موجودی کافی برای پوشش ریفاند و کارمزدها (اگر کارمزد سمت پذیرنده تنظیم شده باشد) است.
- در صورت خالی بودن ولت، پلتفرم مسئولیتی در قبال انجام ریفاند ندارد.

1. عدم بازگشت کارمزد:

- کارمزد ریفاند به حق العمل استرداد و پوشش هزینه سرویس‌های زیرساختی اطلاق میگردد و تنها شامل تراکنش‌های موفق می‌شود.

## 6. مسئولیت‌ها و محدودیت‌ها

1. مرچنت مسئولیت کامل بازگشت وجه و هرگونه پیامد آن را بر عهده دارد.
1. در صورت نقض قوانین یا استفاده غیرمجاز، قابلیت ریفاند پذیرنده بدون اطلاع قبلی غیرفعال خواهد شد.
1. پی‌پینگ هیچ مسئولیتی در قبال اختلافات بین پذیرنده و مشتریان ندارد و تنها به‌عنوان پردازشگر مالی عمل می‌کند.
1. هر تراکنش تنها یکبار امکان استرداد دارد و نمیتوان در دو مرحله آن را عودت داد، پس الزامی است پیش از استرداد وجه مبلغ با دقت تعیین گردد.

## 7. بازبینی و نظارت

1. تمامی فعالیت‌های مرتبط با ریفاند به‌صورت دوره‌ای توسط پلتفرم بررسی و نظارت خواهد شد و تمام تراکنش‌های وی درصورت درخواست نهاد قانونی در اختیار وی قرار خواهد گرفت.
1. مرچنت موظف است در ارائه اطلاعات و پاسخ به درخواست‌های پلتفرم همکاری کامل داشته باشد.

## 8. تغییرات در شرایط و ضوابط

- پلتفرم حق دارد هر زمان این شرایط را به‌روزرسانی کند. در صورت اعمال تغییرات، مرچنت‌ها از طریق ایمیل یا اعلان‌های درون‌پلتفرمی مطلع خواهند شد. ادامه استفاده از قابلیت ریفاند پس از تغییرات به‌معنای پذیرش آن‌ها خواهد بود.

## 9. فسخ و تعلیق سرویس

1. در صورت نقض هر یک از بندهای این توافقنامه، پلتفرم حق دارد سرویس ریفاند مرچنت را تعلیق یا لغو کند.
1. مرچنت می‌تواند با اطلاع قبلی و تسویه تمامی بدهی‌ها، درخواست غیرفعال‌سازی این قابلیت را ارائه دهد.

## 10. قوانین حل اختلاف

- در صورت بروز اختلاف، پذیرنده موظف است موضوع را پیش از هرگونه اقدام قانونی به پلتفرم اطلاع داده و فرصتی برای حل اختلاف ارائه دهد.

## 11. پذیرش شرایط و ضوابط

- فعال‌سازی قابلیت ریفاند به‌منزله پذیرش کامل این شرایط و ضوابط توسط مرچنت است.
